// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"d37eacbf","975":"7a4bd187"}[chunkId] + ".chunk.css";
};